import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EmploymentFormValues } from '../../../../store/types/form/EmploymentFormValues'
import { vacationPeriodHasInvalidNumberOfDays } from '../../../../store/utils/employmentUtils'
import NumericInput from '../../Inputs/NumericInput'

type Props = {
  index: number
}

const VacationPeriodNumberOfDaysInput = ({ index }: Props) => {
  const { t } = useTranslation()
  const { control, getValues } = useFormContext<EmploymentFormValues>()

  return (
    <NumericInput
      control={control}
      name={`vacationPeriods.${index}.numberOfDays`}
      label={t('page.employments.table.numberOfDays')}
      numericType="natural"
      hideHelperText
      rules={{
        min: { value: 1, message: '' },
        validate: {
          invalidNumberOfDays: () => {
            const vacationPeriod = getValues(`vacationPeriods.${index}`)
            if (!vacationPeriod) return true
            if (vacationPeriod.numberOfDays <= 0) {
              return t('page.employments.notifications.invalidNumberOfDays')
            }
            return vacationPeriodHasInvalidNumberOfDays(vacationPeriod)
              ? t('page.employments.notifications.tooManyDays')
              : true
          },
        },
      }}
    />
  )
}

export default VacationPeriodNumberOfDaysInput
